import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";

import './index.sass';

import App from './App';
import 'utils/fonts/index.sass';

Sentry.init({
  dsn: "https://342a9c692249464a9073312b28be65d6@o4507969406828544.ingest.de.sentry.io/4507969411219536",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/otvet\.co\/graphql/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const domNode = document.getElementById('react-root');
const root = ReactDOM.createRoot(domNode);



root.render(<App />);
